import React, { useState } from "react";
import { observer } from "mobx-react-lite";
import { globalVars } from "../../global/GlobalVars.js";
import * as language from "../../utils/language.js";

const DateTime = observer((props) => {
  const [clickCounter, setClickCounter] = useState(0);

  // Websocket Verbingsfehler
  let wsError = false;
  if (globalVars.ws === null) {
    wsError = true;
  }

  // bei 5 Klicks auf Datum/Uhrzeit Seite neu laden
  const handleClick = () => {
    let newClickCounter = clickCounter + 1;
    setClickCounter(newClickCounter);

    if (clickCounter >= 4) {
      document.location.reload();
    }
  };

  return (
    <div
      style={{
        position: "absolute",
        left: props.left,
        right: props.right,
        top: props.top,
      }}
      onClick={handleClick}
    >
      {!wsError && (
        <div style={{ justifyContent: "center", display: "flex" }}>
          {globalVars.dateTime.date}
        </div>
      )}
      {!wsError && (
        <div style={{ justifyContent: "center", display: "flex" }}>
          {globalVars.dateTime.time}
        </div>
      )}
      {wsError && (
        <div
          style={{
            textAlign: "center",
            whiteSpace: "pre-wrap",
          }}
        >
          {language.displayText([
            "Verbindungs-\nfehler",
            "errore di\nconnessione",
            "connection\nerror",
          ])}
        </div>
      )}
    </div>
  );
});

export default DateTime;
